export const apiUrlMap = {
  signup: {
    GET: {
      LIST: "v1/signup/",
      DETAIL: "v1/signup/",
    },
    POST: "v1/signup/",
    PATCH: "v1/signup/",
    DELETE: "v1/signup/",
  },
  passwordReset: {
    GET: {
      LIST: "v1/password/reset/",
      DETAIL: "v1/password/reset/",
    },
    POST: "v1/password/reset/",
    PATCH: "v1/password/reset/",
    DELETE: "v1/password/reset/",
  },
  activate: {
    GET: {
      LIST: "v1/activate/",
      DETAIL: "v1/activate/",
    },
    POST: "v1/activate/",
    PATCH: "v1/activate/",
    DELETE: "v1/activate/",
  },
  passwordResetConfirm: {
    GET: {
      LIST: "v1/password/reset/confirm/",
      DETAIL: "v1/password/reset/confirm/",
    },
    POST: "v1/password/reset/confirm/",
    PATCH: "v1/password/reset/confirm/",
    DELETE: "v1/password/reset/confirm/",
  },
  passwordChange: {
    GET: {
      LIST: "v1/password/change/",
      DETAIL: "v1/password/change/",
    },
    POST: "v1/password/change/",
    PATCH: "v1/password/change/",
    DELETE: "v1/password/change/",
  },
  user: {
    GET: {
      DETAIL: "v2/users/me/",
    },
    PATCH: "v1/user/",
  },
  users: {
    GET: {
      LIST: "v1/users/",
      DETAIL: "v1/users/",
    },
    POST: "v1/users/",
    PATCH: "v1/users/",
    DELETE: "v1/users/",
  },
  sendSlackMessage: {
    GET: {
      LIST: "v1/send_slack_message/",
      DETAIL: "v1/send_slack_message/",
    },
    POST: "v1/send_slack_message/",
    PATCH: "v1/send_slack_message/",
    DELETE: "v1/send_slack_message/",
  },
  serviceMedia: {
    GET: {
      LIST: "v1/service-media/",
      DETAIL: "v1/service-media/",
    },
  },
  serviceJob: {
    GET: {
      LIST: "v1/service-job/",
      DETAIL: "v1/service-job/",
    },
    POST: "v1/service-job/",
    PATCH: "v1/service-job/",
    DELETE: "v1/service-job/",
  },
  submissionJobs: {
    GET: {
      LIST: "v1/report_list/",
      DETAIL: "v1/report_list/",
    },
    POST: "v1/report_list/",
    PATCH: "v1/report_list/",
    DELETE: "v1/report_list/",
  },
  targetIndustries: {
    GET: {
      LIST: "v1/target-industries/",
      DETAIL: "v1/target-industries/",
    },
    POST: "v1/target-industries/",
    PATCH: "v1/target-industries/",
    DELETE: "v1/target-industries/",
  },
  contactUs: {
    GET: {
      LIST: "v1/contact-us/",
      DETAIL: "v1/contact-us/",
    },
    POST: "v1/contact-us/",
    PATCH: "v1/contact-us/",
    DELETE: "v1/contact-us/",
  },
  teamMembers: {
    GET: {
      LIST: "v1/team/members/",
      DETAIL: "v1/team/members/",
    },
    POST: "v1/team/members/",
    PATCH: "v1/team/members/",
    DELETE: "v1/team/members/",
  },
  teamMember: {
    GET: {
      LIST: "v1/team/member/",
      DETAIL: "v1/team/member/",
    },
    POST: "v1/team/member/",
    PATCH: "v1/team/member/",
    PUT: "v1/team/member/",
    DELETE: "v1/team/member/",
  },
  teamRoles: {
    GET: {
      LIST: "v1/team/roles/",
      DETAIL: "v1/team/roles/",
    },
    POST: "v1/team/roles/",
    PATCH: "v1/team/roles/",
    DELETE: "v1/team/roles/",
  },
  team: {
    GET: {
      LIST: "v1/team/",
      DETAIL: "v1/team/",
    },
    POST: "v1/team/",
    PATCH: "v1/team/",
    DELETE: "v1/team/",
  },
  // v2 team management api
  teamV2: {
    GET: { DETAIL: "v2/team/" },
    PATCH: "v2/team/",
  },
  teamMemberV2: {
    POST: "v2/team/members/",
    PATCH: "v2/team/members/",
  },
  explanation: {
    GET: {
      LIST: "v1/explanation/",
      DETAIL: "v1/explanation/",
    },
    POST: "v1/explanation/",
    PATCH: "v1/explanation/",
    DELETE: "v1/explanation/",
  },
  createJWT: {
    POST: "v2/jwt/create/",
  },
  refreshJWT: {
    POST: "v2/jwt/refresh/",
  },
  verifyJWT: {
    POST: "v2/jwt/verify/",
  },
  analytics: {
    GET: {
      LIST: "v1/reports/download/",
    },
  },
  integrations: {
    GET: {
      LIST: "v1/integrations/",
    },
  },
  submission: {
    GET: {
      LIST: "v1/submissions/",
      DETAIL: "v1/submissions/",
    },
    DELETE: "v1/submissions/",
    BULK_DELETE: "v1/report/delete/",
  },
  integrationConnect: {
    GET: "v1/connect/",
  },
  integrationDisconnect: {
    DELETE: "v1/integrations/",
  },
  category: {
    POST: "/v2/category/deepfake_detection/",
  },
  submissionsUpload: {
    POST: "v2/submissions/upload/",
    COMPLETE: "v2/submissions/{id}/complete/",
  },
  products: {
    GET: {
      LIST: "v2/products/",
    },
  },
  productGroups: {
    GET: {
      LIST: "v2/product-groups/",
      DETAIL: "v2/product-groups/",
    },
  },
  webhooks: {
    GET: {
      LIST: "v2/webhooks/",
      DETAIL: "v2/webhooks/",
    },
    POST: "v2/webhooks/",
    PUT: "v2/webhooks/",
    DELETE: "v2/webhooks/",
  },
  webhookEvents: {
    GET: {
      LIST: "v2/webhook-events/",
      DETAIL: "v2/webhook-events/",
    },
    POST: {
      RETRY: "v2/webhook-events/",
    },
  },
  apiKeys: {
    GET: {
      LIST: "v1/api-keys/",
      DETAIL: "v1/api-keys/",
    },
    POST: "v1/api-keys/",
    PUT: "v1/api-keys/",
    DELETE: "v1/api-keys/",
  },
  submissionsUsage: {
    GET: {
      DETAIL: "v1/submissions/usage/",
    },
  },
  licence: {
    GET: {
      DETAIL: "v2/licence/",
    },
  },
  archive: {
    GET: {
      DETAIL: "/v2/annotation/video/",
      DOWNLOAD: "/v2/annotation/video/{jobId}/",
    },
    POST: "/v2/annotation/video/",
  },
  submissionExports: {
    GET: {
      LIST: "/v2/submissions/exports/",
      DOWNLOAD: "/v2/submissions/exports/{exportId}/",
    },
    POST: "/v2/submissions/exports/",
  },
};

export const onPremUrlMap = {
  ...apiUrlMap,
};
